import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take, Observable } from 'rxjs';
import { isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { UserStatus } from '../interfaces/user-status.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  private platformId = inject(PLATFORM_ID);
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(): boolean | Observable<boolean> {
    if (isPlatformServer(this.platformId)) {
      console.log('Server-side render, allowing access');
      return true;
    }

    return this.authService.user$.pipe(
      take(1),
      map(user => {
        console.log('Auth guard check:', user);
        if (user && user.status === UserStatus.APPROVED) {
          return true;
        } else if (user && user.status === UserStatus.PENDING) {
          this.router.navigate(['/pending-approval']);
          return false;
        }
        console.log('No user, redirecting to login');
        this.router.navigate(['/login']);
        return false;
      })
    );
  }
}